<template>
  <BaseAction>
    <SecondaryButton
      :loading="updating"
      @click.native="markComplete"
      color="primary"
    >
      <div class="d-flex justify-center">
        <svg
          width="27"
          height="33"
          viewBox="0 0 27 33"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask id="path-1-inside-1" fill="white">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M17.3072 0H3C1.34315 0 0 1.34314 0 3V30C0 31.6569 1.34314 33 3 33H23.4C25.0569 33 26.4 31.6569 26.4 30V9.1559L17.3072 0Z"
            />
          </mask>
          <path
            d="M17.3072 0L18.7263 -1.40931L18.1397 -2H17.3072V0ZM26.4 9.1559H28.4V8.33152L27.8191 7.74658L26.4 9.1559ZM3 2H17.3072V-2H3V2ZM2 3C2 2.44772 2.44771 2 3 2V-2C0.238577 -2 -2 0.238575 -2 3H2ZM2 30V3H-2V30H2ZM3 31C2.44771 31 2 30.5523 2 30H-2C-2 32.7614 0.23857 35 3 35V31ZM23.4 31H3V35H23.4V31ZM24.4 30C24.4 30.5523 23.9523 31 23.4 31V35C26.1614 35 28.4 32.7614 28.4 30H24.4ZM24.4 9.1559V30H28.4V9.1559H24.4ZM27.8191 7.74658L18.7263 -1.40931L15.8881 1.40931L24.9809 10.5652L27.8191 7.74658Z"
            fill="white"
            mask="url(#path-1-inside-1)"
          />
          <path
            d="M7.43662 24.1682C10.1076 20.8301 15.1143 10.589 12.0618 9.40211C8.24606 7.91851 4.76564 22.3137 10.8707 23.0555C16.9758 23.7973 19.2665 18.198 18.1218 17.4562C17.8871 17.3041 15.3257 15.219 14.3934 17.9038C13.3304 20.9648 15.3239 22.3135 19.5211 24.1682"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <span :class="{ 'ml-1': isMobile }"> Mark as Complete </span>
    </SecondaryButton>
  </BaseAction>
</template>

<script>
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import BaseAction from "@/components/common/BaseAction";
import { MARK_OFFER_STEP_COMPLETE } from "@/store/modules/offers/actions";
import { OFFERS_NAMESPACE } from "@/store/modules/offers";
import { createNamespacedHelpers } from "vuex";

const { mapActions } = createNamespacedHelpers(OFFERS_NAMESPACE);

export default {
  props: {
    stepId: String
  },
  components: {
    BaseAction,
    SecondaryButton
  },
  data() {
    return {
      updating: false
    };
  },
  methods: {
    ...mapActions({
      markAsComplete: MARK_OFFER_STEP_COMPLETE
    }),
    async markComplete() {
      this.updating = true;
      await this.markAsComplete(this.stepId);
      this.updating = false;
      this.$emit("updated");
    }
  }
};
</script>
